import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { USER_ROLES } from '../../../../constants';
import { changeSessionsTableSettings, selectSessionFromHistory } from '../../../../redux/story/storyReducer';
import { useProject } from '../../../../context/ProjectContext';

function useSessionHistory({ isActive = true, fetchOnMount = false } = {}) {
  const dispatch = useDispatch();
  const { actions } = useProject();
  const { id: projectId } = useParams();

  const sessionId = useSelector((state) => state.story.sessionId);
  const userStatus = useSelector((state) => state.securityNew.userStatus);
  const currentUsername = useSelector((state) => state.securityNew.currentUserInfo.username);
  const sessionsTableSettings = useSelector((state) => state.story.sessionsTableSettings);
  const sessionsData = useSelector((state) => state.story.sessionsData);
  const { page, size, sort, username, totalElements } = sessionsTableSettings;

  const isAdmin = userStatus.includes(USER_ROLES.GLOBAL_ADMIN);
  const shouldFetch = Boolean(projectId && (isActive || fetchOnMount));

  const handleSelectSession = useCallback(
    ({ id, message }) => {
      if (id === sessionId) {
        return;
      }

      dispatch(
        selectSessionFromHistory({
          id,
          message,
          usedMedia: [],
        }),
      );
    },
    [dispatch, sessionId],
  );

  const handleChangePage = useCallback(
    (newPage) => {
      dispatch(changeSessionsTableSettings({ page: newPage }));
    },
    [dispatch],
  );

  useEffect(() => {
    if (!isAdmin && currentUsername) {
      dispatch(changeSessionsTableSettings({ username: currentUsername, page: 0 }));
    }
  }, [isAdmin, currentUsername, dispatch]);

  useEffect(() => {
    if (!shouldFetch) {
      return;
    }

    actions('searchSession', { projectId });
  }, [shouldFetch, projectId, page, size, sort, username, actions]);

  return {
    isAdmin,
    sessionsData,
    totalElements,
    page,
    handleSelectSession,
    handleChangePage,
  };
}

export default useSessionHistory;
